import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {IDialogConfirmationHandler} from "../../../services/dialog/dialog.service.interface";

const StandardDialogContentBox = styled.div`
    height: 100%;
    overflow: hidden;
`

const StandardDialogChildrenContentBox = styled.div`
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: ${props => props.theme.spacing.dialogVerticalPadding} ${props => props.theme.spacing.dialogHorizontalPadding};
`

interface StandardDialogContentComponentProps extends PropsWithChildren {
    className?: string;
    dialogHandler: IDialogConfirmationHandler;
    childrenContainerClassName?: string;
}
export const StandardDialogContentComponent: React.FC<StandardDialogContentComponentProps> = observer((props) => {


    return (
        <StandardDialogContentBox className={props.className}>
            <StandardDialogChildrenContentBox className={props.childrenContainerClassName} onScroll={(event) => {
                const scrollTop =  (event.target as any)?.scrollTop ?? 0;
                props.dialogHandler.hasScroll = scrollTop > 4;
            }}>
                {props.children}
            </StandardDialogChildrenContentBox>

        </StandardDialogContentBox>
    )
});
